import React from 'react';

const Header: React.FC = () => {
  return (
    <div className="navbar-wrapper">
      <div className="navbar-container">
        <header className="navbar">
          <div className="navbar-row">
            <a href="https://givingfortheliving.com" className="brand" target="_blank" rel="noopener noreferrer">
              <img
                src="https://cdn.prod.website-files.com/64c3b921c726d86b1bc94a0a/64c3b921c726d86b1bc94b0b_GFTL_LOGO_RGB.svg"
                alt="Giving For The Living"
                className="logo-image"
              />
            </a>
            <div className="navbar-right">
              <a
                href="https://linkly.link/2RJRB"
                className="button nav-button"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download the App
              </a>
            </div>
          </div>
        </header>
      </div>
    </div>
  );
};

export default Header;
